import { useTranslation } from 'react-i18next';

import icon from 'assets/icons/globe-asia-australia.svg';

const CapitalPopover = () => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="bg-gray-900 rounded-lg p-4 w-[300px] mt-1 shadow-2xl">
      <div className="flex items-center mb-2.5">
        <img src={icon} alt="Working Capital Orchestration" />
      </div>
      <p className="text-gray-50 font-bold mb-1.5">
        {t('progress.capital.title')}
      </p>
      <p className="text-gray-300 text-sm">{t('progress.capital.text')}</p>
    </div>
  );
};

export default CapitalPopover;
